enum FileSelectionContainerType {
    Printing,
    Attachment,
    ImportFiles
}

export { FileSelectionContainerType };
